import {
  WITHDRAWAL_RESOURCE,
  FINANCIAL_ADJUSTMENTS,
  READ_ACTION,
  MANAGE_ACTION,
  FINANCIAL_MANAGMENT,
  PAYMENT_IMPORT,
  COMMISSION_MANAGEMENT,
  EXPENSE,
  INVOICE_BILLING,
  MY_COMMISSIONS_MENU,
  DISCOUNT_COUPON,
  COMMISSION_SHAREHOLDER_DNA_EQUITY,
  COMMISSION_SHAREHOLDER_DNA_PRESENTATION,
  FINANCIAL_SHAREHOLDER_DNA_EQUITY,
  FINANCIAL_SHAREHOLDER_DNA_PRESENTATION,
  SNAPSHOT_CHANGE,
} from "@/constants/resources";

const fixedFinancialMenuRole = { fixedFinancialMenuRole: true };

export default [
  {
    title: "Comissões",
    icon: "none",
    children: [
      {
        title: "Minhas comissões",
        route: "commissions",
        icon: "DollarSignIcon",
        resource: MY_COMMISSIONS_MENU,
        action: READ_ACTION,
      },
      {
        title: "Solicitações de snapshot",
        route: "snapshot-change-requests-list",
        icon: "PieChartIcon",
        resource: SNAPSHOT_CHANGE,
        action: READ_ACTION,
      },
      {
        title: "Meus pagamentos",
        route: "withdrawal-list",
        icon: "CreditCardIcon",
        resource: WITHDRAWAL_RESOURCE,
        action: READ_ACTION,
      },
      {
        title: "Calculadora Equity",
        href: "https://docs.google.com/spreadsheets/d/1jG4wCi8mr0Tx2U_mvIZBCOeyZxY0UJnk/edit?gid=598103734&utm_source=chatgpt.com#gid=598103734",
        icon: "ExternalLinkIcon",
        resource: COMMISSION_SHAREHOLDER_DNA_EQUITY,
        action: READ_ACTION,
      },
      {
        title: "Apresentação do Programa",
        href: "https://www.canva.com/design/DAGSQgDp56Y/7YVaVVlxkGFOUFhtlJbq-Q/edit?utm_content=DAGSQgDp56Y&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton",
        icon: "ExternalLinkIcon",
        resource: COMMISSION_SHAREHOLDER_DNA_PRESENTATION,
        action: READ_ACTION,
      },
    ],
  },
  {
    title: "Financeiro",
    icon: "none",
    resource: FINANCIAL_MANAGMENT,
    action: READ_ACTION,
    ...fixedFinancialMenuRole,
    children: [
      {
        title: "Ajustes",
        route: "financial-adjustments-list",
        icon: "Edit3Icon",
        resource: FINANCIAL_ADJUSTMENTS,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Contas a pagar",
        route: "financial-management-payables",
        icon: "BookIcon",
        resource: FINANCIAL_MANAGMENT,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Receitas",
        route: "commission-management",
        icon: "DollarSignIcon",
        resource: COMMISSION_MANAGEMENT,
        action: MANAGE_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Despesas",
        route: "expenses-list",
        icon: "DivideIcon",
        resource: EXPENSE,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Importação de receitas",
        route: "payment-importer",
        icon: "UploadIcon",
        resource: PAYMENT_IMPORT,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Cupons de desconto",
        route: "discount-coupons",
        icon: "PercentIcon",
        resource: DISCOUNT_COUPON,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Faturamento",
        route: "financial-managment-invoices",
        icon: "LayersIcon",
        resource: INVOICE_BILLING,
        action: MANAGE_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Calculadora Equity",
        href: "https://docs.google.com/spreadsheets/d/1jG4wCi8mr0Tx2U_mvIZBCOeyZxY0UJnk/edit?gid=598103734&utm_source=chatgpt.com#gid=598103734",
        icon: "ExternalLinkIcon",
        resource: FINANCIAL_SHAREHOLDER_DNA_EQUITY,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
      {
        title: "Apresentação do Programa",
        href: "https://www.canva.com/design/DAGSQgDp56Y/7YVaVVlxkGFOUFhtlJbq-Q/edit?utm_content=DAGSQgDp56Y&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton",
        icon: "ExternalLinkIcon",
        resource: FINANCIAL_SHAREHOLDER_DNA_PRESENTATION,
        action: READ_ACTION,
        ...fixedFinancialMenuRole,
      },
    ],
  },
];
